import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const ErrorPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const {
    errorMessage = "Something went wrong",
    statusCode = null,
    retryPath = null,
    redirectAfterSuccess = null,
    method = "GET",
    headers = {},
    isAuthError = false,
  } = location.state || {};

  const retryFetch = () => {
    if (!retryPath) return;

    fetch(retryPath, {
      method,
      headers,
    })
      .then((res) => res.json().then(data => ({ status: res.status, data })))
      .then(({ status, data }) => {
        if (status === 200 && data.status !== "error") {
          // Extract ID or fallback route for redirection
          const id = retryPath.split("/").pop();
          navigate(`/app/ExpertDetails/${id}`);
        } else {
          alert(data.text || "Retry failed again.");
        }
      })
      .catch((err) => {
        console.error("Retry failed:", err);
        alert("Retry failed due to network error.");
      });
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#365561] px-4">
      <motion.div
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="bg-white shadow-xl rounded-2xl p-8 max-w-md w-full text-center border"
      >
        <motion.div
          animate={{ rotate: [0, 10, -10, 0] }}
          transition={{ repeat: Infinity, duration: 2 }}
          className="text-6xl mb-4 text-red-500"
        >
          ⚠️
        </motion.div>
        {/* <h1 className="text-2xl font-bold text-gray-800 mb-2">{statusCode ? `Authentication Error (${statusCode})` : `Authentication Error`}</h1> */}
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          {errorMessage.toLowerCase().includes("expired")
            ? "Session Expired"
            : statusCode
            ? `Authentication Error (${statusCode})`
            : "Authentication Error"}
        </h1>
        <p className="text-gray-600 mb-6">{errorMessage.toLowerCase().includes("expired") ? "Please login to refresh the session" : errorMessage}</p>

        <div className="flex flex-col gap-3">
          {retryPath && !isAuthError && (
            <button
              onClick={retryFetch}
              className="bg-yellow-500 text-white px-4 py-2 rounded-lg shadow hover:bg-yellow-600 transition focus:outline-none"
            >
              Retry
            </button>
          )}

          <button
            onClick={() =>
              isAuthError
                ? navigate("/", { state: { redirectAfterLogin: redirectAfterSuccess } })
                : navigate("/")
            }
            className="bg-[#365561] text-white px-4 py-2 rounded-lg shadow hover:bg-[#2b4450] transition focus:outline-none"
          >
            Login
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default ErrorPage;